import { Component } from '@angular/core';

@Component({
  selector: 'app-typebedroom-list',
  templateUrl: './typebedroom-list.component.html',
  styleUrls: ['./typebedroom-list.component.css']
})
export class TypebedroomListComponent {

}
